<template>
  <div class="formCom">
    <div class="form">
      <div class="name">
        Warning
      </div>
      <div class="subtitle">
        You are about to delete <span>{{ AdminInfo.fullname }}</span>
      </div>
      <div class="txt">
        This action is irreversible. If you complete it now, you can't restore
        any relatable information later
      </div>
      <div class="txt sub">
        Are you sure you want to delete this admin?
      </div>
      <div class="button-wrap">
        <button class="btn" @click="remove">
          Delete
        </button>
        <button class="btn close" @click="closeConfurmModal">
          No, I’ll keep it
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CloseIcone from "../../images/shared/cancel";

export default {
  name: "ConfurmModal",
  props: ["AdminInfo"],
  components: {
    CloseIcone
  },
  methods: {
    ...mapActions(["removeAdmin", "getAdminInfoList"]),
    closeConfurmModal() {
      this.$emit("closeConfurmModal", false);
    },
    remove() {
      this.removeAdmin(this.AdminInfo.id).then(res => {
        this.getAdminInfoList("admins").then(res => {
          this.$emit("closeConfurmModal", false);
        });
      });
    }
  }
};
</script>

<style scoped>
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.form {
  padding: 30px;
  background-color: #fff;
  max-width: 400px;
  border-radius: 5px;
  width: 100%;
  position: relative;
  z-index: 1;
}
.button-wrap {
  width: 80%;
  margin: 0 auto 15px auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.name {
  color: #005eb8;
  font-size: 24px;
  margin: 0 0 30px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.btn {
  background-color: #62b039;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  outline: none;
  border: none;
  height: 45px;
  border-radius: 25px;
  max-width: 300px;
  width: 100%;
  margin: 0 auto 10px auto;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsMedium, sans-serif;
}
.btn.close {
  color: #62b039;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  margin: 0 auto;
  background-color: transparent;
  font-size: 18px;
  font-family: TTNormsMedium, sans-serif;
}
.subtitle {
  font-size: 15px;
  font-family: TTNormsLight, sans-serif;
  color: #005eb8;
  text-align: center;
  margin: 0 0 20px 0;
}
.subtitle span {
  font-family: TTNormsMedium, sans-serif;
}
.txt {
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  color: #333;
  margin: 0 0 40px 0;
}
.txt.sub {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
  color: #333;
  text-align: center;
  margin: 0 0 20px 0;
}
</style>
